<template>
  <div>
    <div class="card mb-5 mb-xxl-8 ">
      <div class="card-header flex-wrap border-0 pt-6 pb-0">
        <div class="card-title">
          <h3 class="card-label"></h3>
        </div>
        <div class="card-toolbar">
          <Select2
              v-model="statusSelected"
              :isRequired="false"
              :multiple="false"
              :show-search="false"
              :placeholderText="$t('e-commerce.checkout.status')"
              :selectClass="'form-select form-select-solid kt_select2 w-200px'"
              containerClass="d-flex flex-column fv-row me-5 mw-500px"
              name="checkout-status"
          >

            <option v-for="(status, index) in getPosCheckoutStatus" :key="index" :value="status.value">
              {{ $i18n.locale == 'fr' ? status.fr : status.en }}
            </option>
          </Select2>
        </div>
      </div>
      <div class="card-body">
        <table class="table align-middle table-row-bordered fs-6 gy-3" id="kt_datatable_session_sale"
               style="margin-top: 2px !important; cursor:pointer">
          <thead>
          <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
            <th>{{ $t('session.commande_num') }}</th>
            <th>{{ $t('session.customer') }}</th>
            <th>{{ $t('session.total') }} </th>
            <th>{{ $t('session.date') }}</th>
            <th>{{ $t('session.status') }}</th>
            <th>{{ $t("actions") }}</th>
          </tr>
          </thead>
        </table>
      </div>
    </div>
    <TicketModal
      :sale="formEditData"
      :currency="currency"
      :is-load="isLoad"
      :is-loading="isLoading"
      :symef-response="symefResponse"
      @print="printButton"
      @normalize="generateSymefInvoice"
    />
  </div>
</template>

<script>
import { BASE_URL } from "@/services/api";
import TicketModal from "@/components/TicketModal";
import {mapActions, mapGetters} from 'vuex'
import {Settings} from "luxon";
import {nextTick} from "vue";
import Select2 from "@/components/Select2";

export default {
  components: {
    TicketModal,
    Select2
  },
  name: "Sales",
  data() {
    return {
      formEditData: {
        id: null,
        row: null,
        reference: '',
        customer: '',
        sub_total: 0,
        reduction: 0,
        cash_change: 0,
        shop_address: '',
        shop_phone: '',
        shop_name: '',
        operator: '',
        amountDonated: 0,
        products: [],
        isNormalized: false,
        acompte_amount: 0,
        acompte_remaining: 0,
        status: '',
        ifu_number: '',
        phone: '',
        phone_code: '',
        first_address_infos: '',
        customer_email: ''
      },
      symefResponse: {},
      isLoad: true,
      isLoading: true,
      currency: '',
      startDate: null,
      endDate: null,
      statusSelected: 'all',
      checkout_id: null
    }
  },
 watch :{
   '$i18n.locale': function(value){
     Settings.defaultLocale = value
     if(value && this.table){
       nextTick(() => {
         this.fetchDatas()
       })
     }
   },

   'startDate' : function(value){
     if(this.startDate ){
       this.$nextTick(() =>    this.fetchDatas())
     }
   },

   'statusSelected' : function(value){
     if(value ){
       let url =  BASE_URL +'/get/session/' + this.$route.params.sessionId + '/sales/datatables' + `?startDate=${this.startDate}&endDate=${this.endDate}&status=${this.statusSelected}`
       this.table.ajax.url(url).load()

     }
   },
 },
  computed : {
    locale() {
      return this.$i18n?.locale ?? localStorage.getItem('locale');
    },
    ...mapGetters('shop', [
      'getPosCheckoutStatus'
    ]),
  },

  async mounted() {
    Settings.defaultLocale = localStorage.getItem('locale')

    await  this.fetchDatas()
    this.loadPosCheckoutStatus()

    $(document).on("click", "#kt_datatable_session_sale .edit_btn", async (e) => {
      this.checkout_id = e.target.getAttribute('data-id')
      await this.verifySymefInvoice()
      this.isLoad = false

      this.formEditData.id = e.target.getAttribute('data-id')
      this.formEditData.row = e.target.getAttribute('data-row')
      this.formEditData.reference = e.target.getAttribute('data-ref')
      this.formEditData.customer = e.target.getAttribute('data-customer')
      this.formEditData.sub_total = e.target.getAttribute('data-sub-total')
      this.formEditData.total = e.target.getAttribute('data-total')
      this.formEditData.reduction = e.target.getAttribute('data-reduction')
      this.formEditData.shop_address = e.target.getAttribute('data-shop-address')
      this.formEditData.shop_phone = e.target.getAttribute('data-shop-phone')
      this.formEditData.shop_name = e.target.getAttribute('data-shop-name')
      this.formEditData.shop_ifu_number = e.target.getAttribute('data-shop-ifu')
      this.formEditData.shop_rccm_number = e.target.getAttribute('data-shop-rccm')
      this.formEditData.operator = e.target.getAttribute('data-operator')
      this.formEditData.date = e.target.getAttribute('data-date')
      this.formEditData.cash_change = e.target.getAttribute('data-cash-change')
      this.formEditData.amountDonated = e.target.getAttribute('data-amountDonated')
      this.formEditData.products = JSON.parse(decodeURIComponent(e.target.getAttribute('data-products')))
      this.formEditData.acompte_amount = JSON.parse(e.target.getAttribute('data-acompte-amount'))
      this.formEditData.acompte_remaining = JSON.parse(e.target.getAttribute('data-acompte-remaining'))
      this.formEditData.status = e.target.getAttribute('data-status')
      this.formEditData.ifu_number = e.target.getAttribute('data-ifu')
      this.formEditData.first_address_infos = e.target.getAttribute('data-customer-address')
      this.formEditData.phone = e.target.getAttribute('data-phone')
      this.formEditData.phone_code = e.target.getAttribute('data-phone-code')
      this.formEditData.customer_email = e.target.getAttribute('data-customer-email')
    });
    let response = await this.getCurrency()
    this.currency = response.data.currency_symbol ? response.data.currency_symbol : response.data.symbol_native

  },

  methods: {
    ...mapActions('session', ['normalizationInvoice', 'verifyInvoiceNormalization']),
    ...mapActions('shop', ['getCurrency','loadPosCheckoutStatus']),
    async generateSymefInvoice() {
      this.isLoading = true
      this.isLoad = true
      try {
        let response = await this.normalizationInvoice(this.checkout_id)
        this.symefResponse = response.data
        window.toastr['success'](i18n.global.t('shop.success_invoice'))
      } catch (e) {
      }
      this.isLoad = false
      this.isLoading = false
    },
    async verifySymefInvoice() {
      this.isLoading = true
      this.isLoad = true
      this.isNormalized = false
      let response = await this.verifyInvoiceNormalization(this.checkout_id)
      this.symefResponse = response.data
      if (this.symefResponse) {
        this.isNormalized = true
      }
      this.isLoad = false
      this.isLoading = false
    },

    advanceAmount() {
      return  parseFloat(this.formEditData.acompte_amount)

    },
    remainingAmount() {

      return   parseFloat(this.formEditData.acompte_remaining)

    },
    fetchDatas() {
      const AUTH_TOKEN = Ls.get('auth.token')
      this.table = $("#kt_datatable_session_sale").DataTable({
        destroy : true,
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength: Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100],
        order: [[0, 'desc']],
        ajax: {
          url: BASE_URL + '/get/session/' + this.$route.params.sessionId + '/sales/datatables',
          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          },
          data: function (d) {
          }
        },
        columns: [{ data: "reference" }, { data: "customer" }, { data: "total" }, { data: "date" }, { data: "status" }, { data: "Actions", responsivePriority: -1 }],
        columnDefs: [
          {
            targets: -6,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -5,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow' + l.row + '">' + t + "</span>";
            },
          },

          {
            targets: -4,
            order: "desc",
            className: "dt-center clickable",
            render: (t, a, e, l) => {
              return '<span data-id="' + e.id + '"  class="typeRow' + l.row + '">' + this.$formatLocalAmount(t) + "<span> "+ this.currency +"</span></span>";
            },
          },
          {
            targets: -3,
            order: "desc",
            render: function (t, a, e, l) {
              return '<span class="nameRow' + l.row + '">' + t + "</span>";
            },
          },
          {
            targets: -2,
            orderable:false,
            searchable:false,
            render:  (t, a, e, l) => {
              const type = this.getStatusClass(t)
              let status = this.getStatusLocale(t)
              return '<span data-id="'+ e.id +'" class="'+ type +' text-'+type+'">' + status + "</span>";

            },
          },
          {
            targets: -1,
            "className": "dt-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {
              let render = ""
              const encodedProducts = encodeURIComponent(JSON.stringify(e.products))
              render += '<button data-bs-toggle="modal" data-bs-target="#kt_modal_1" type="button" data-id="' + e.id + '"  data-row="' + l.row + '" data-ref="' + e.reference + '" data-operator="' + e.operator + '"   data-shop-name="' + e.shop_name + '"   data-shop-phone="' + e.shop_phone + '"   data-shop-address="' + e.shop_address + '"  data-shop-ifu="' + (e.shop_ifu_number || '') + '"  data-shop-rccm="' + (e.shop_rccm_number || '') + '"  data-reduction="' + e.reduction + '" data-sub-total="' + e.sub_total + '" data-total="' + e.total + '" data-customer="' + e.customer + '" data-date="' + e.date + '" data-cash-change="' + e.cash_change + '" data-amountDonated="' + e.amountDonated + '" data-acompte-amount="' + e.acompte_amount + '"   data-acompte-remaining="' + e.acompte_remaining + '" data-status="' + e.status + '"  data-customer-email="' + (e.customer_email || '') + '"  data-ifu="' + (e.ifu_number || '') + '"  data-phone="' + (e.phone || '') + '"  data-phone-code="' + (e.phone_code || '') + '" data-customer-address="' + (e.first_address_infos || '') + '" data-products="' + encodedProducts + '" class="btn btn-icon btn-active-light-primary w-30px h-30px ms-auto me-5 edit_btn" >' +
                  '<i  data-id="' + e.id + '"  data-row="' + l.row + '"   data-ref="' + e.reference + '" data-operator="' + e.operator + '"   data-shop-name="' + e.shop_name + '"   data-shop-phone="' + e.shop_phone + '"   data-shop-address="' + e.shop_address + '"  data-shop-ifu="' + (e.shop_ifu_number || '') + '"  data-shop-rccm="' + (e.shop_rccm_number || '') + '"  data-reduction="' + e.reduction + '" data-sub-total="' + e.sub_total + '" data-total="' + e.total + '" data-customer="' + e.customer + '"  data-date="' + e.date + '" data-cash-change="' + e.cash_change + '" data-amountDonated="' + e.amountDonated + '"  data-acompte-amount="' + e.acompte_amount + '"   data-acompte-remaining="' + e.acompte_remaining + '" data-status="' + e.status + '"  data-ifu="' + (e.ifu_number || '') + '"  data-phone="' + (e.phone || '') + '"  data-phone-code="' + (e.phone_code || '') + '"  data-customer-email="' + (e.customer_email || '') + '" data-customer-address="' + (e.first_address_infos || '') + '" data-products="' + encodedProducts + '"  class="fa fa-eye"></i>' +
                  '</button>'

              return render
            },
          },
        ],
        language: {
          url: this.locale == 'fr' ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json" : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json",
        }
      });
    },

    getStatusClass(statut){
      let posCheckoutStatus =   this.getPosCheckoutStatus.find(stat => stat.value === statut)
      if(posCheckoutStatus){
        return posCheckoutStatus.className
      }
      return ''

    },

    getStatusLocale(statut){
      let checkoutStatus = this.getPosCheckoutStatus.find(stat => stat.value === statut)
      if(checkoutStatus){
        if(this.locale === 'fr'){
          return  checkoutStatus.fr
        }else{
          return  checkoutStatus.en
        }
      }
      return ''

    },
    printButton() {
      let prtHtml = document.getElementById('invoice');
      let WinPrint = window.open('', 'Print-Window', 'left=0,top=0,width=400,height=600,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
        <head>
          <title>Ticket</title>
          <style>
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body {
              font-family: 'Courier New', Courier, monospace;
              font-size: 12px;
              width: 80mm;
              padding: 5mm;
            }
            table { width: 100%; border-collapse: collapse; }
            td { padding: 2px 0; vertical-align: top; font-size: 12px; }
            .text-center { text-align: center; }
            .text-right { text-align: right; }
            .company-name { font-size: 16px; font-weight: bold; }
            .separator { text-align: center; color: #000; padding: 5px 0 !important; }
            .separator-light { border-bottom: 1px solid #eee; padding: 3px 0 !important; }
            .product-name-cell { width: 55%; }
            .product-price-cell { width: 45%; text-align: right; }
            .discount-text { font-size: 10px; font-style: italic; }
            .ifu-rccm-line { font-size: 9px !important; }
            .nowrap-unit { white-space: nowrap; }
            .payment-row td { color: #333; }
            .total-final-row td { font-size: 14px; font-weight: bold; padding-top: 5px !important; }
            .remaining-row td { font-weight: bold; }
            .qr-section { margin-top: 10px; padding: 8px; border: 1px solid #000; }
            .qr-table td { font-size: 10px; padding: 1px 0; }
            .qr-code { text-align: center; margin-top: 8px; }
            .receipt-footer { text-align: center; margin-top: 10px; }
            .thanks-text { font-weight: bold; text-transform: uppercase; letter-spacing: 1px; }
            @media print {
              body { width: 80mm; margin: 0; padding: 2mm; }
              @page { margin: 0; size: 80mm auto; }
            }
          </style>
        </head>
        <body>${prtHtml.innerHTML}</body>
        </html>`);
      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(() => { WinPrint.print(); }, 250);
    },

  }
}
</script>

